export class RelatedDocsView {
    public document: number;
    public relatedDoc: number;
    public agent: number;
    public relatedAmount: number;
    public currency: string;

    constructor(document, relatedDoc, agent, relatedAmount, currency) {
      this.document = document;
      this.relatedDoc = relatedDoc;
      this.agent = agent;
      this.relatedAmount = relatedAmount;
      this.currency = currency;
    }
}
